var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip",value:(_vm.tooltip),expression:"tooltip"},{name:"gl-resize-observer",rawName:"v-gl-resize-observer",value:(_vm.onResize),expression:"onResize"}],staticClass:"gl-min-w-0",class:_vm.classes},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }